enum MedicaidParentOrganizationSortingTypeEnum {
  AlphabeticalAsc = "Alphabetical (A-Z)",
  AlphabeticalDesc = "Alphabetical (Z-A)",
  MembershipCountDesc = "Membership Count (high to low)",
  MembershipCountAsc = "Membership Count (low to high)",
}

export { MedicaidParentOrganizationSortingTypeEnum };
